import {PaymentsRepositoryImpl} from '../repository/PaymentsRepositoryImpl';
import {GetPaymentsUseCase} from '../useCases/GetPaymentsUseCase';
import {GetPaymentsWithFiltersUseCase} from '../useCases/GetPaymentsWithFiltersUseCase';
import {GetPaymentStatisticsUseCase} from '../useCases/GetPaymentStatisticsUseCase';

// Singleton pattern for payments instances
class PaymentsFactory {
  private static instance: PaymentsFactory;
  private repository: PaymentsRepositoryImpl;
  private useCases: {
    getPayments: GetPaymentsUseCase;
    getPaymentsWithFilters: GetPaymentsWithFiltersUseCase;
    getPaymentStatistics: GetPaymentStatisticsUseCase;
  };

  private constructor () {
    this.repository = new PaymentsRepositoryImpl();
    this.useCases = {
      getPayments: new GetPaymentsUseCase(this.repository),
      getPaymentsWithFilters: new GetPaymentsWithFiltersUseCase(this.repository),
      getPaymentStatistics: new GetPaymentStatisticsUseCase(this.repository)
    };
  }

  public static getInstance (): PaymentsFactory {
    if (!this.instance) {
      this.instance = new PaymentsFactory();
    }
    return this.instance;
  }

  public getUseCases () {
    return this.useCases;
  }

  public getRepository () {
    return this.repository;
  }
}

export const paymentsFactory = PaymentsFactory.getInstance();
